<dashboardnav>
    <cradua-seismic-program [programs]="programs$ | async" (program)="onSubmitProgram($event)" (deleteProgramEvent)="onDeleteProgram($event)"
      *ngIf="(isLoadingProgram$ | async ) === false">
    </cradua-seismic-program>
  
    <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingProgram$ | async) === true">
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
  